import React, { useEffect, useState } from 'react';
import { Button, ButtonGroup, Dialog, Grid, makeStyles, TextField } from '@material-ui/core';
import MUIDataTable from 'mui-datatables';
import swal from '@sweetalert/with-react';
import moment from 'moment';
import axiosInstance, { EVENT_ID, getEventId, saveDeadline, stripHtml, WEB_API } from '../constatns';
import CssBaseline from '@material-ui/core/CssBaseline';
import AdminTopbar from './AdminTopbar';
import { BarChart, Create, Delete } from '@material-ui/icons';
import IconButton from '@material-ui/core/IconButton';
import Popout from 'react-popout-new';
import AdminFooter from './AdminFooter';
import SaveIcon from '@material-ui/icons/Save';
import FreePaperSubmissionForm from '../freepaper/FreePaperSubmissionForm';
import FreePaperSubmissionConfirm from '../freepaper/FreePaperSubmissionConfirm';
import TableToolBarCustom from '../components/MuiDataTableCustom/TableToolBarCustom';
import TableToolbarExtra from '../components/MuiDataTableCustom/TableToolbarExtra';
import TableFilterList from '../components/MuiDataTableCustom/TableFilterList';
import PaperStatistics from './dialog/PaperStatistics';
import { CountryList } from '../common/CountryList';
import CircularProgress from '@material-ui/core/CircularProgress';

const useStyles = makeStyles((theme) => ({
  root: {
    minHeight: 800,
    overflow: 'auto',
    '& .MuiPaper-root': {
      boxShadow: 'none',
      border: '1px solid rgba(224, 224, 224, 1)',
    },
    '& .MuiTableCell-root': {
      textAlign: 'center',
      fontSize: '13px',
      '& span': {
        display: 'block',
        wordBreak: 'keep-all',
      },
      '& button': {
        fontSize: '13px',
      },
    },
  },
  link: {
    cursor: 'pointer',
    textDecoration: 'underline',
    '&:hover': {
      color: theme.palette.secondary.main,
    },
  },
}));

const PaperListPage = (props) => {
  const { history } = props;
  const classes = useStyles();
  const [userData, setUserData] = useState();
  const [data, setData] = useState();
  const [alldata, setAllData] = useState();
  const [selectFilter, setSelectFilter] = useState('all');
  const [selectTypeFilter, setSelectTypeFilter] = useState('all');
  const [open, setOpen] = useState(false);
  const [openView, setOpenView] = useState(false);
  const [openChart, setOpenChart] = useState(false);
  const [selectData, setSelectData] = useState(false);
  const [openPreview, setOpenPreview] = useState(false);
  const [openUrlPreview, setOpenUrlPreview] = useState('');
  const [openResend, setOpenResend] = useState(false);
  const [openUrlResend, setOpenUrlResend] = useState('');
  const [count, setCount] = useState({});
  const [countCountry, setCountCountry] = useState({});
  const EVT = JSON.parse(sessionStorage.getItem('EVENT'));
  const [deadline, setDeadline] = useState(EVT && EVT.paperDeadline ? EVT.paperDeadline : moment().format('YYYY-MM-DDTHH:mm').toString());

  let cols = [
    {
      name: 'id',
      label: 'No',
      options: {
        filter: false,
        sort: true,
        viewColumns: false,
        download: false,
        customBodyRender: (value, tableMeta, updateValue) => {
          return tableMeta.tableData.length - tableMeta.rowIndex;
        },
      },
    },

    // filter rowIndex 수정
    {
      name: 'paperRegNo',
      label: '접수번호',
      options: {
        filter: false,
        sort: true,
        viewColumns: false,
        customBodyRender: (value, tableMeta, updateValue) => {
          // const _info = data[tableMeta.rowIndex];
          const item = data.find((f) => f.paperRegNo === value);
          return (
            <span
              className={classes.link}
              // onClick={(e) => showView(_info.id, _info)}
              onClick={(e) => showView(item.id, item)}
            >
              {value}
            </span>
          );
        },
      },
    },
    {
      name: 'id',
      // name: 'isReg',
      label: '사전등록여부',
      options: {
        filter: false,
        sort: false,
        viewColumns: false,
        download: false,
        customBodyRender: (value, tableMeta, updateValue) => {
          const item = data.find((f) => f.id === value);
          // const info = data[tableMeta.rowIndex];
          const user = userData.find((u) => {
            // return u.id === info.writer;
            return u.id === item.writer;
          });
          return user && user.isPay === 'P' ? 'X' : 'O';
        },
      },
    },
    {
      // name: 'isPay',
      name: 'id',
      label: '등록비결제',
      options: {
        filter: false,
        sort: false,
        viewColumns: false,
        download: false,
        customBodyRender: (value, tableMeta, updateValue) => {
          const item = data.find((f) => f.id === value);
          // const info = data[tableMeta.rowIndex];
          const user = userData.find((u) => {
            // return u.id === info.writer;
            return u.id === item.writer;
          });
          return user && user.isPay === 'R' && user.status === 'Complete' ? 'O' : 'X';
          // return data[tableMeta.rowIndex].userInfo &&
          //   data[tableMeta.rowIndex].userInfo.isPay === 'R' &&
          //   data[tableMeta.rowIndex].userInfo.status === 'Complete'
          //   ? 'O'
          //   : 'X';
        },
      },
    },
    // {
    //   name: 'abstractNo',
    //   label: '초록번호',
    //   options: {
    //     filter: false,
    //     sort: true,
    //     viewColumns: false,
    //     customBodyRender: (value, tableMeta, updateValue) => {
    //       return '-';
    //     },
    //   },
    // },
    {
      name: 'status',
      label: 'Status',
      options: {
        filter: true,
        sort: true,
        viewColumns: false,
        customBodyRender: (value, tableMeta, updateValue) => {
          const _color = value === 'Complete' ? 'blue' : 'red';
          return (
            <span style={{ color: _color }} onClick={(e) => console.log('')}>
              {value}
            </span>
          );
        },
      },
    },
    {
      name: 'writer',
      label: 'ID',
      options: {
        filter: false,
        sort: false,
        viewColumns: false,
        customBodyRender: (value, tableMeta, updateValue) => {
          return value ? value.replace(EVENT_ID + '_', '') : '';
        },
      },
    },
    // {
    //   name: 'country',
    //   label: 'Country',
    //   options: {
    //     filter: true,
    //     sort: true,
    //     viewColumns: false,
    //     customBodyRender: (value, tableMeta, updateValue) => {
    //       const info = data[tableMeta.rowIndex];
    //       console.log(info);
    //       // console.log(userData.find(u => u.id === info.));
    //
    //       return data[tableMeta.rowIndex].userInfo && data[tableMeta.rowIndex].userInfo.country;
    //     },
    //   },
    // },
    {
      name: 'presentationType',
      label: 'Presentation Type',
      options: {
        filter: true,
        sort: true,
        viewColumns: false,
      },
    },
    {
      // name: 'selectPresentingAuthor',
      name: 'id',
      label: '발표자',
      options: {
        filter: false,
        sort: true,
        viewColumns: false,
        download: false,
        customBodyRender: (value, tableMeta, updateValue) => {
          const item = data.find((f) => f.id === value);
          // const _info = data[tableMeta.rowIndex];
          const findAuthor = item.numOfAuthor ? item.numOfAuthor.find((ah) => ah.id === item.selectPresentingAuthor) : null;
          // const findAuthor = _info.numOfAuthor ? _info.numOfAuthor.find((ah) => ah.id === _info) : null;
          return findAuthor ? findAuthor.firstName + ' ' + findAuthor.lastName : '';
        },
      },
    },
    {
      name: 'selectPresentingAuthorName',
      label: 'Presenting Name',
      options: {
        filter: false,
        sort: false,
        viewColumns: false,
        display: false,
      },
    },
    {
      name: 'selectPresentingAuthorInstitution',
      label: 'Presenting Institution',
      options: {
        filter: false,
        sort: false,
        viewColumns: false,
        display: false,
      },
    },
    {
      name: 'selectPresentingAuthorCountry',
      label: 'Presenting Country',
      options: {
        filter: false,
        sort: false,
        viewColumns: false,
        display: false,
      },
    },
    {
      name: 'selectPresentingAuthorEmail',
      label: 'Presenting Email',
      options: {
        filter: false,
        sort: false,
        viewColumns: false,
        display: false,
      },
    },
    {
      name: 'selectPresentingAuthorCategory',
      label: 'Presenting Category',
      options: {
        filter: false,
        sort: false,
        viewColumns: false,
        display: false,
      },
    },
    {
      name: 'selectPresentingAuthorMobile',
      label: 'Presenting Mobile',
      options: {
        filter: false,
        sort: false,
        viewColumns: false,
        display: false,
      },
    },
    {
      name: 'id',
      // name: 'selectCorrespondingAuthor',
      label: '책임저자',
      options: {
        filter: false,
        sort: true,
        viewColumns: false,
        download: false,
        customBodyRender: (value, tableMeta, updateValue) => {
          const item = data.find((f) => f.id === value);
          // const _info = data[tableMeta.rowIndex];
          const findAuthor = item.numOfAuthor ? item.numOfAuthor.find((ah) => ah.id === item.selectCorrespondingAuthor) : null;
          // const findAuthor = _info.numOfAuthor ? _info.numOfAuthor.find((ah) => ah.id === value) : null;
          return findAuthor ? findAuthor.firstName + ' ' + findAuthor.lastName : '';
        },
      },
    },
    {
      name: 'abstractTopic',
      label: 'Abstract Topic',
      options: {
        filter: false,
        sort: true,
        viewColumns: false,
      },
    },
    {
      name: 'selectCorrespondingAuthorName',
      label: 'Corresponding Name',
      options: {
        filter: false,
        sort: false,
        viewColumns: false,
        display: false,
      },
    },
    {
      name: 'selectCorrespondingAuthorInstitution',
      label: 'Corresponding Institution',
      options: {
        filter: false,
        sort: false,
        viewColumns: false,
        display: false,
      },
    },
    {
      name: 'selectCorrespondingAuthorCountry',
      label: 'Corresponding Country',
      options: {
        filter: false,
        sort: false,
        viewColumns: false,
        display: false,
      },
    },
    {
      name: 'selectCorrespondingAuthorEmail',
      label: 'Corresponding Email',
      options: {
        filter: false,
        sort: false,
        viewColumns: false,
        display: false,
      },
    },
    {
      name: 'selectCorrespondingAuthorCategory',
      label: 'Corresponding Category',
      options: {
        filter: false,
        sort: false,
        viewColumns: false,
        display: false,
      },
    },
    {
      name: 'selectCorrespondingAuthorMobile',
      label: 'Corresponding Mobile',
      options: {
        filter: false,
        sort: false,
        viewColumns: false,
        display: false,
      },
    },
    {
      // name: 'abstractTitle',
      name: 'id',
      label: 'Title',
      options: {
        filter: false,
        sort: false,
        viewColumns: false,
        download: false,
        customBodyRender: (value, tableMeta, updateValue) => {
          const item = data.find((f) => f.id === value);
          // const _info = data[tableMeta.rowIndex];
          return (
            // <span className={classes.link} onClick={(e) => showPreview(_info.id)}>
            <span className={classes.link} onClick={(e) => showPreview(item.id)}>
              {item.abstractTitle}
            </span>
          );
        },
      },
    },
    {
      name: 'abstractTitle',
      label: 'Title',
      options: {
        filter: false,
        sort: false,
        viewColumns: false,
        display: false,
        download: true,
      },
    },
    {
      name: 'purposeContent',
      label: 'Purpose',
      options: {
        filter: false,
        sort: false,
        viewColumns: false,
        display: false,
      },
    },
    {
      name: 'methodsContent',
      label: 'Methods',
      options: {
        filter: false,
        sort: false,
        viewColumns: false,
        display: false,
      },
    },
    {
      name: 'resultsContent',
      label: 'Results',
      options: {
        filter: false,
        sort: false,
        viewColumns: false,
        display: false,
      },
    },
    {
      name: 'conclusionContent',
      label: 'Conclusion',
      options: {
        filter: false,
        sort: false,
        viewColumns: false,
        display: false,
      },
    },
    {
      name: 'figures1',
      label: 'Figures 1',
      options: {
        filter: false,
        sort: false,
        viewColumns: false,
        display: false,
      },
    },
    {
      name: 'figures2',
      label: 'Figures 2',
      options: {
        filter: false,
        sort: false,
        viewColumns: false,
        display: false,
      },
    },
    {
      name: 'figures3',
      label: 'Figures 3',
      options: {
        filter: false,
        sort: false,
        viewColumns: false,
        display: false,
      },
    },
    {
      name: 'figures4',
      label: 'Figures 4',
      options: {
        filter: false,
        sort: false,
        viewColumns: false,
        display: false,
      },
    },
    {
      name: 'createdAt',
      label: '접수일',
      options: {
        filter: false,
        sort: true,
        customBodyRender: (value, tableMeta, updateValue) => {
          const dt = moment(Number(value));
          return dt.tz('Asia/Seoul').format('YYYY-MM-DD HH:mm:ss');
        },
      },
    },
    {
      name: 'updatedAt',
      label: '최종 수정일',
      options: {
        filter: false,
        sort: true,
        download: false,
        customBodyRender: (value, tableMeta, updateValue) => {
          const dt = moment(Number(value));
          return value ? dt.tz('Asia/Seoul').format('YYYY-MM-DD HH:mm:ss') : '';
        },
      },
    },
    {
      name: 'result',
      label: '심사결과',
      options: {
        filter: false,
        sort: true,
        customBodyRender: (value, tableMeta, updateValue) => {
          return value ? `${value} 채택` : '-';
        },
      },
    },
    {
      name: 'file',
      label: '발표파일',
      options: {
        filter: false,
        sort: true,
        customBodyRender: (value, tableMeta, updateValue) => {
          // return '-';
          return value ? <a href={value.path}>{value.name}</a> : '-';
        },
      },
    },
    {
      name: 'isAgree1',
      label: 'Do you agree on changing your presentation type between oral presentation and E-Poster after acceptance?',
      options: {
        filter: false,
        sort: false,
        viewColumns: false,
        display: false,
      },
    },
    {
      name: 'isAgree2',
      label: 'Copyright Agreement',
      options: {
        filter: false,
        sort: false,
        viewColumns: false,
        display: false,
      },
    },
    {
      name: 'id',
      label: 'Mail',
      options: {
        filter: false,
        sort: true,
        download: false,
        customBodyRender: (value, tableMeta, updateValue) => {
          return (
            <Button color={'primary'} size={'small'} variant={'contained'} disableElevation onClick={(e) => sendEmail(value)}>
              Resend
            </Button>
          );
        },
      },
    },
    {
      name: 'id',
      label: '관리',
      options: {
        filter: false,
        sort: true,
        download: false,
        customBodyRender: (value, tableMeta, updateValue) => {
          const isDel = selectFilter === 'cancel';
          return (
            <div>
              <IconButton aria-label="update" onClick={() => setUpdateAction(value, tableMeta, updateValue)}>
                <Create fontSize="small" />
              </IconButton>
              <IconButton
                aria-label="delete"
                // onClick={() => setDeleteAction(tableMeta)}
                onClick={() => setDeleteAction(value)}
              >
                <Delete fontSize="small" />
              </IconButton>
            </div>
          );
        },
      },
    },
  ];

  const sendEmail = (val) => {
    setOpenUrlResend(`/#/admin/Resend?type=paper&id=${val}`);
    if (openResend) {
      setOpenResend(false);
      setTimeout(function () {
        setOpenResend(true);
      }, 300);
    } else {
      setOpenResend(true);
    }
  };

  const showPreview = (val) => {
    if (val) {
      setOpenUrlPreview(`/#/admin/paper/Preview?paperId=${val}`);
    } else {
      setOpenUrlPreview(`/#/admin/paper/Preview`);
    }
    if (openPreview) {
      setOpenPreview(false);
      setTimeout(function () {
        setOpenPreview(true);
      }, 300);
    } else {
      setOpenPreview(true);
    }
  };
  const showView = (val, info) => {
    setSelectData(info);
    if (openView) {
      setOpenView(false);
      setTimeout(function () {
        setOpenView(true);
      }, 300);
    } else {
      setOpenView(true);
    }
  };

  const setUpdateAction = (val, meta, updateVal) => {
    // filter rowIndex 수정
    const item = data.find((f) => f.id === val);
    if (selectFilter === 'cancel') {
      swal({
        title: '선택한 항목을 복구하시겠습니까?',
        text: '',
        icon: 'warning',
        buttons: true,
        dangerMode: true,
      }).then((willDelete) => {
        if (willDelete) {
          axiosInstance
            .put(`${WEB_API}/paper/restore`, {
              eventId: EVENT_ID,
              // paperId: data[meta.rowIndex].id,
              paperId: item.id,
            })
            .then((res) => {
              setSelectFilter('all');
              getPaperData();
            })
            .catch((err) => {
              console.error(err);
            });
        }
      });
    } else {
      // setSelectData(data[meta.rowIndex]);
      setSelectData(item);
      if (open) {
        setOpen(false);
        setTimeout(function () {
          setOpen(true);
        }, 300);
      } else {
        setOpen(true);
      }
    }
  };

  // const setDeleteAction = (meta) => {
  const setDeleteAction = (value) => {
    // filter rowIndex 수정
    const item = data.find((f) => f.id === value);
    swal({
      title: '정말 삭제하시겠습니까?',
      text: selectFilter === 'cancel' ? '삭제 후 복구할수 없습니다.' : '',
      // text: selectFilter === 'cancel' ? `${item.id}` : `${item.id}`,
      icon: 'warning',
      buttons: true,
      dangerMode: true,
    }).then((willDelete) => {
      if (willDelete) {
        if (selectFilter === 'cancel') {
          axiosInstance
            .delete(`${WEB_API}/paper/?eventId=${EVENT_ID}&paperId=${item.id}`)
            .then((res) => {
              getPaperData();
              handleFilter('cancel');
            })
            .catch((err) => {
              console.error(err);
            });
        } else {
          axiosInstance
            .put(`${WEB_API}/paper/del`, {
              eventId: EVENT_ID,
              paperId: item.id,
            })
            .then((res) => {
              getPaperData();
            })
            .catch((err) => {
              console.error(err);
            });
        }
      }
    });
  };

  const onPreview = () => {
    showPreview();
  };
  const onDown = () => {
    setOpenUrlPreview(`/#/admin/paper/Preview?type=download`);
    if (openPreview) {
      setOpenPreview(false);
      setTimeout(function () {
        setOpenPreview(true);
      }, 300);
    } else {
      setOpenPreview(true);
    }
  };

  const options = {
    print: false,
    filterType: 'dropdown',
    viewColumns: false,
    selectableRows: 'none',
    downloadOptions: {
      filename: `abstract_${moment().valueOf()}.xls`,
    },
    searchOpen: true,
    customToolbar: () => {
      return <TableToolbarExtra onPreview={onPreview} onDownload={onDown} />;
    },
    customSearch: (searchQuery, currentRow, columns) => {
      let isFound = false;
      data.map((member) => {
        if (member.id === currentRow[0]) {
          for (const [key, value] of Object.entries(member)) {
            if (typeof value === 'string') {
              const val = value.toLowerCase().replace(/ /gi, '').replace(/-/gi, '').replace(/\+/gi, '');
              const search = searchQuery.toLowerCase().replace(/ /gi, '').replace(/-/gi, '').replace(/\+/gi, '');
              if (val.indexOf(search) !== -1) isFound = true;
            }
          }
        }
      });
      return isFound;
    },
    onDownload: (buildHead, buildBody, columns, _data) => {
      const maxAuthor = data.reduce(function (max, p) {
        return p.numOfAuthor.length > max ? p.numOfAuthor.length : max;
      }, data[0].numOfAuthor.length);
      const maxIns = data.reduce(function (max, p) {
        return p.numOfInstitution.length > max ? p.numOfInstitution.length : max;
      }, data[0].numOfInstitution.length);

      for (let i = 0; i < maxAuthor; i++) {
        columns.push({ name: `author${i + 1}`, label: `Author ${i + 1}`, download: true });
      }
      for (let j = 0; j < maxIns; j++) {
        columns.push({ name: `institution${j + 1}`, label: `Institution ${j + 1}`, download: true });
      }

      const dt = columns.findIndex((d) => d.name === 'createdAt');
      const writer = columns.findIndex((d) => d.name === 'writer');
      const selectPresentingAuthor = columns.findIndex((d) => d.name === 'selectPresentingAuthorName');
      const selectPresentingAuthorInstitution = columns.findIndex((d) => d.name === 'selectPresentingAuthorInstitution');
      const selectPresentingAuthorCountry = columns.findIndex((d) => d.name === 'selectPresentingAuthorCountry');
      const selectPresentingAuthorCategory = columns.findIndex((d) => d.name === 'selectPresentingAuthorCategory');
      const selectPresentingAuthorEmail = columns.findIndex((d) => d.name === 'selectPresentingAuthorEmail');
      const selectPresentingAuthorMobile = columns.findIndex((d) => d.name === 'selectPresentingAuthorMobile');
      const selectCorrespondingAuthor = columns.findIndex((d) => d.name === 'selectCorrespondingAuthorName');
      const selectCorrespondingAuthorInstitution = columns.findIndex((d) => d.name === 'selectCorrespondingAuthorInstitution');
      const selectCorrespondingAuthorCountry = columns.findIndex((d) => d.name === 'selectCorrespondingAuthorCountry');
      const selectCorrespondingAuthorCategory = columns.findIndex((d) => d.name === 'selectCorrespondingAuthorCategory');
      const selectCorrespondingAuthorEmail = columns.findIndex((d) => d.name === 'selectCorrespondingAuthorEmail');
      const selectCorrespondingAuthorMobile = columns.findIndex((d) => d.name === 'selectCorrespondingAuthorMobile');

      const purposeContent = columns.findIndex((d) => d.name === 'purposeContent');
      const methodsContent = columns.findIndex((d) => d.name === 'methodsContent');
      const resultsContent = columns.findIndex((d) => d.name === 'resultsContent');
      const conclusionContent = columns.findIndex((d) => d.name === 'conclusionContent');

      const figures1 = columns.findIndex((d) => d.name === 'figures1');
      const figures2 = columns.findIndex((d) => d.name === 'figures2');
      const figures3 = columns.findIndex((d) => d.name === 'figures3');
      const figures4 = columns.findIndex((d) => d.name === 'figures4');

      const fileIdx = columns.findIndex((d) => d.name === 'file');
      const resultIdx = columns.findIndex((d) => d.name === 'result');

      // console.log(columns);
      // paper_1630857522716
      let retVal = [];

      _data.map((_d) => {
        if (dt !== -1) {
          _d.data[dt] = moment(Number(_d.data[dt])).tz('Asia/Seoul').format('YYYY-MM-DD HH:mm');
        }
        if (writer !== -1) {
          _d.data[writer] = _d.data[writer].replace(EVENT_ID + '_', '');
        }
        // console.log(_d);
        const _info = data[_d.index];
        const selectPresenting = data[_d.index].selectPresentingAuthor;
        const findAuthor = _info.numOfAuthor.find((ah) => ah.id === selectPresenting);
        const findAuthorIns = _info.numOfInstitution.find((ah) => ah.id === findAuthor.ino1);

        const selectCorresponding = data[_d.index].selectCorrespondingAuthor;
        const findCorrespondingAuthor = _info.numOfAuthor.find((ah) => ah.id === selectCorresponding);
        const findCorrespondingAuthorIns = findCorrespondingAuthor
          ? _info.numOfInstitution.find((ah) => ah.id === findCorrespondingAuthor.ino1)
          : null;

        for (let a = 0; a < _info.numOfAuthor.length; a++) {
          const authorIdx = columns.findIndex((d) => d.name === 'author' + (a + 1));
          const author = _info.numOfAuthor[a];
          const authorIns = _info.numOfInstitution.find((ah) => ah.id === author.ino1);
          const isPresenting = author.id === findAuthor.id ? 'Y' : 'N';
          const isCorresponding = findCorrespondingAuthor && author.id === findCorrespondingAuthor.id ? 'Y' : 'N';
          if (authorIdx !== -1) {
            _d.data[
              authorIdx
            ] = `Name : ${author.firstName} ${author.lastName}\nInstitution : ${authorIns.affiliation}\nPresenting author : ${isPresenting}\nCorresponding Author : ${isCorresponding}`;
          }
        }
        for (let ins = 0; ins < _info.numOfInstitution.length; ins++) {
          const insIdx = columns.findIndex((d) => d.name === 'institution' + (ins + 1));
          const insInfo = _info.numOfInstitution[ins];
          if (insIdx !== -1) {
            _d.data[
              insIdx
            ] = `Department : ${insInfo.department}\nAffiliation : ${insInfo.affiliation}\nCity/State : ${insInfo.city}\nCountry : ${insInfo.country}`;
          }
        }

        if (selectPresentingAuthor !== -1) {
          _d.data[selectPresentingAuthor] = findAuthor.firstName + ' ' + findAuthor.lastName;
        }
        if (selectPresentingAuthorInstitution !== -1) {
          _d.data[selectPresentingAuthorInstitution] = findAuthorIns.affiliation;
        }
        if (selectPresentingAuthorCountry !== -1) {
          _d.data[selectPresentingAuthorCountry] = findAuthor.country;
        }
        if (selectPresentingAuthorCategory !== -1) {
          _d.data[selectPresentingAuthorCategory] = findAuthor.category;
        }
        if (selectPresentingAuthorEmail !== -1) {
          _d.data[selectPresentingAuthorEmail] = findAuthor.email;
        }
        if (selectPresentingAuthorMobile !== -1) {
          _d.data[selectPresentingAuthorMobile] = findAuthor.phoneNumber;
        }

        if (selectCorrespondingAuthor !== -1) {
          _d.data[selectCorrespondingAuthor] = findCorrespondingAuthor
            ? findCorrespondingAuthor.firstName + ' ' + findCorrespondingAuthor.lastName
            : '';
        }
        if (selectCorrespondingAuthorInstitution !== -1) {
          _d.data[selectCorrespondingAuthorInstitution] = findCorrespondingAuthorIns ? findCorrespondingAuthorIns.affiliation : '';
        }
        if (selectCorrespondingAuthorCountry !== -1) {
          _d.data[selectCorrespondingAuthorCountry] = findCorrespondingAuthor ? findCorrespondingAuthor.country : '';
        }
        if (selectCorrespondingAuthorCategory !== -1) {
          _d.data[selectCorrespondingAuthorCategory] = findCorrespondingAuthor ? findCorrespondingAuthor.category : '';
        }
        if (selectCorrespondingAuthorEmail !== -1) {
          _d.data[selectCorrespondingAuthorEmail] = findCorrespondingAuthor ? findCorrespondingAuthor.email : '';
        }
        if (selectCorrespondingAuthorMobile !== -1) {
          _d.data[selectCorrespondingAuthorMobile] = findCorrespondingAuthor ? findCorrespondingAuthor.phoneNumber : '';
        }

        if (purposeContent !== -1) {
          _d.data[purposeContent] = stripHtml(_d.data[purposeContent]);
        }
        if (methodsContent !== -1) {
          _d.data[methodsContent] = stripHtml(_d.data[methodsContent]);
        }
        if (resultsContent !== -1) {
          _d.data[resultsContent] = stripHtml(_d.data[resultsContent]);
        }
        if (conclusionContent !== -1) {
          _d.data[conclusionContent] = stripHtml(_d.data[conclusionContent]);
        }
        if (figures1 !== -1 && _d.data[figures1]) {
          _d.data[figures1] = '=HYPERLINK("' + _d.data[figures1].path + '","' + _d.data[figures1].name + '")';
        }
        if (figures2 !== -1 && _d.data[figures2]) {
          _d.data[figures2] = '=HYPERLINK("' + _d.data[figures2].path + '","' + _d.data[figures2].name + '")';
        }
        if (figures3 !== -1 && _d.data[figures3]) {
          _d.data[figures3] = '=HYPERLINK("' + _d.data[figures3].path + '","' + _d.data[figures3].name + '")';
        }
        if (figures4 !== -1 && _d.data[figures4]) {
          _d.data[figures4] = '=HYPERLINK("' + _d.data[figures4].path + '","' + _d.data[figures4].name + '")';
        }
        if (fileIdx !== -1 && _d.data[fileIdx]) {
          _d.data[fileIdx] = '=HYPERLINK("' + _d.data[fileIdx].path + '","' + _d.data[fileIdx].name + '")';
        }
        if (resultIdx !== -1 && _d.data[resultIdx]) {
          _d.data[resultIdx] = _d.data[resultIdx] ? `${_d.data[resultIdx]} 채택` : '';
        }
        retVal.push(_d);
        return _d;
      });

      // console.log(columns);
      const body = buildBody(retVal).replace(/\'/gi, '');
      return '\uFEFF' + buildHead(columns) + body;
    },
  };

  const getUserData = () => {
    let url = `${WEB_API}/user/list?eventId=${getEventId()}&limit=-1`;
    axiosInstance.get(`${url}`, { headers: { Pragma: 'no-cache' } }).then((response) => {
      setUserData(response.data.Items);
      getPaperData(false, response.data.Items);
    });
  };

  const getPaperData = (_isDel, users) => {
    let final = [];
    function getServer(_lastKey) {
      let url = `${WEB_API}/paper/listSimple?eventId=${getEventId()}&limit=-1`;
      if (_isDel) url += '&isDel=true';
      if (_lastKey) {
        url += `&lastKey=${encodeURIComponent(_lastKey.id)}&lastVal=${_lastKey.evt}&lastValName=evt`;
      }
      axiosInstance
        .get(`${url}`, {
          headers: { Pragma: 'no-cache' },
        })
        .then((res) => {
          res.data.Items.forEach(function (itemdata) {
            final.push(itemdata);
          });

          if (typeof res.data.LastEvaluatedKey !== 'undefined') {
            // console.log(res.data.LastEvaluatedKey);
            getServer(res.data.LastEvaluatedKey);
          } else {
            const arrData = final.sort((a, b) => {
              return Number(b.createdAt) - Number(a.createdAt);
            });
            // console.log(arrData);
            setData(arrData);
            if (!_isDel) {
              setAllData(arrData);
            }
          }
        });
    }
    getServer();

    // axiosInstance.get(`${url}`, { headers: { Pragma: 'no-cache' } }).then((response) => {
    //   console.log(response.data)
    //   const arrData = response.data.sort((a, b) => {
    //     return Number(b.createdAt) - Number(a.createdAt);
    //   });
    //   // console.log(arrData);
    //   setData(arrData);
    //   if (!_isDel) {
    //     setAllData(arrData);
    //   }
    // });
  };

  const doSaveDeadline = () => {
    saveDeadline(deadline, 'paperDeadline');
  };

  useEffect(() => {
    getUserData();
    // getPaperData();
  }, []);

  const handleClose = () => {
    getPaperData();
    setOpen(false);
    setOpenView(false);
    setOpenChart(false);
  };

  const handleFilter = (_filter) => {
    setSelectFilter(_filter);
    if (_filter === 'all') {
      setData(alldata);
    } else {
      getPaperData(true);
    }
  };

  const showChart = () => {
    setCount({
      oral: 0,
      eposter: 0,
      basic: 0,
      craniofacial: 0,
      handnupper: 0,
      headnneck: 0,
      breast: 0,
      lowerlimb: 0,
      lymphedema: 0,
      eyelid: 0,
      rhinoplasty: 0,
      antiaging: 0,
      facial: 0,
      aesthetic: 0,
      bodycontouring: 0,
      botox: 0,
      laser: 0,
      fatnstem: 0,
      hair: 0,
      other: 0,
    });
    data.map((item) => {
      setCount((prevState) => ({
        ...count,
        oral: item.presentationType === 'Oral' ? prevState['oral'] + 1 : prevState['oral'],
        eposter: item.presentationType === 'E-Poster' ? prevState['eposter'] + 1 : prevState['eposter'],
        basic: item.abstractTopic === 'Basic Research' ? prevState['basic'] + 1 : prevState['basic'],
        craniofacial: item.abstractTopic === 'Craniofacial / Trauma' ? prevState['craniofacial'] + 1 : prevState['craniofacial'],
        handnupper: item.abstractTopic === 'Hand & Upper Limb Reconstruction' ? prevState['handnupper'] + 1 : prevState['handnupper'],
        headnneck: item.abstractTopic === 'Head and Neck Reconstruction' ? prevState['headnneck'] + 1 : prevState['headnneck'],
        breast: item.abstractTopic === 'Breast / Body Reconstruction' ? prevState['breast'] + 1 : prevState['breast'],
        lowerlimb: item.abstractTopic === 'Lower Limb Reconstruction' ? prevState['lowerlimb'] + 1 : prevState['lowerlimb'],
        lymphedema: item.abstractTopic === 'Lymphedema' ? prevState['lymphedema'] + 1 : prevState['lymphedema'],
        eyelid: item.abstractTopic === 'Eyelid and Periocular Surgery' ? prevState['eyelid'] + 1 : prevState['eyelid'],
        rhinoplasty: item.abstractTopic === 'Rhinoplasty' ? prevState['rhinoplasty'] + 1 : prevState['rhinoplasty'],
        antiaging: item.abstractTopic === 'Anti-aging Surgery' ? prevState['antiaging'] + 1 : prevState['antiaging'],
        facial: item.abstractTopic === 'Facial Contouring Surgery' ? prevState['facial'] + 1 : prevState['facial'],
        aesthetic: item.abstractTopic === 'Aesthetic Breast Surgery' ? prevState['aesthetic'] + 1 : prevState['aesthetic'],
        bodycontouring: item.abstractTopic === 'Body Contouring Surgery' ? prevState['bodycontouring'] + 1 : prevState['bodycontouring'],
        botox: item.abstractTopic === 'Botox, Filler, Minimally Invasive Surgery' ? prevState['botox'] + 1 : prevState['botox'],
        laser: item.abstractTopic === 'Laser' ? prevState['laser'] + 1 : prevState['laser'],
        fatnstem: item.abstractTopic === 'Fat and Stem Cell Therapy' ? prevState['fatnstem'] + 1 : prevState['fatnstem'],
        hair: item.abstractTopic === 'Hair' ? prevState['hair'] + 1 : prevState['hair'],
        other: item.abstractTopic === 'Other Plastic Surgery' ? prevState['other'] + 1 : prevState['other'],
      }));
    });

    // 국가별 통계
    let buff = [];
    for (let i = 0; i < CountryList.length; i++) {
      // if (CountryList[i].name !== 'Korea, Republic of') {
      buff.push({
        name: CountryList[i].name,
        count: 0,
      });
      // }
    }
    if (data) {
      for (let i = 0; i < data.length; i++) {
        for (let j = 0; j < buff.length; j++) {
          if (buff[j].name === data[i].userInfo.country) {
            buff[j].count += 1;
          }
        }
      }
    }

    setCountCountry(buff);

    setOpenChart(true);
  };

  const handleTypeFilter = (_filter) => {
    setSelectTypeFilter(_filter);
    if (_filter === 'all') {
      setData(alldata);
    } else {
      const newData = alldata.filter((d) => {
        return d.result === _filter;
      });
      setData(newData);
    }
  };

  return (
    <Grid item xs={12}>
      <CssBaseline />
      <AdminTopbar MIdx={2} SIdx={0} />
      <Grid container alignItems={'stretch'} direction="column" style={{ padding: 16 }} className={classes.root}>
        <Grid item>
          <Grid container spacing={4} justifyContent={'flex-start'} alignItems={'center'}>
            <Grid item>
              <h1>Free Paper</h1>
            </Grid>
            <Grid item>
              <ButtonGroup color="primary" disableElevation>
                <Button variant={selectFilter === 'all' ? 'contained' : 'outlined'} onClick={() => handleFilter('all')}>
                  All Abstract
                </Button>
                <Button variant={selectFilter === 'cancel' ? 'contained' : 'outlined'} onClick={() => handleFilter('cancel')}>
                  Cancel List
                </Button>
              </ButtonGroup>
            </Grid>
            <Grid item>
              <Grid container alignItems={'center'} justifyContent={'center'}>
                <Grid item>
                  <TextField
                    style={{ marginRight: 5 }}
                    id="datetime-local"
                    label="초록등록 마감 일시"
                    type="datetime-local"
                    defaultValue={deadline}
                    onChange={(e) => setDeadline(e.target.value)}
                    InputLabelProps={{
                      shrink: true,
                    }}
                  />
                </Grid>
                <Grid item>
                  <Button color="secondary" variant={'outlined'} startIcon={<SaveIcon />} onClick={doSaveDeadline} disableElevation>
                    저장
                  </Button>
                </Grid>
                <Grid item style={{ marginLeft: 100 }}>
                  <Button
                    color="primary"
                    variant={'outlined'}
                    startIcon={<BarChart />}
                    onClick={() => history.push('/admin/paperStatus')}
                    disableElevation
                  >
                    통계
                  </Button>
                </Grid>
              </Grid>
            </Grid>
          </Grid>
        </Grid>
        <Grid item style={{ marginBottom: '1em' }}>
          <ButtonGroup color="primary" disableElevation>
            <Button variant={selectTypeFilter === 'all' ? 'contained' : 'outlined'} onClick={() => handleTypeFilter('all')}>
              All
            </Button>
            <Button variant={selectTypeFilter === 'Oral' ? 'contained' : 'outlined'} onClick={() => handleTypeFilter('Oral')}>
              Oral
            </Button>
            <Button variant={selectTypeFilter === 'E-Poster' ? 'contained' : 'outlined'} onClick={() => handleTypeFilter('E-Poster')}>
              E-Poster
            </Button>
            <Button variant={selectTypeFilter === 'None' ? 'contained' : 'outlined'} onClick={() => handleTypeFilter('None')}>
              미채택
            </Button>
          </ButtonGroup>
        </Grid>
        <Grid item>
          <MUIDataTable
            title={''}
            data={data}
            columns={cols}
            options={options}
            components={{ TableToolbar: TableToolBarCustom, TableFilterList: TableFilterList }}
          />
        </Grid>
      </Grid>
      <AdminFooter />
      {openView ? (
        <Dialog
          open={openView}
          fullWidth
          maxWidth={'lg'}
          onClose={handleClose}
          aria-labelledby="alert-dialog-title"
          aria-describedby="alert-dialog-description"
        >
          <FreePaperSubmissionConfirm
            mode={'review'}
            abstractId={selectData.id}
            isPop={true}
            isAdmin={true}
            infoData={selectData}
            data={selectData}
            handleClose={handleClose}
          />
        </Dialog>
      ) : null}
      {openChart ? <PaperStatistics count={count} countCountry={countCountry} openChart={openChart} handleClose={handleClose} /> : null}
      {openPreview ? (
        <Popout url={openUrlPreview} title="PRS2022-ADMIN-PAPERPREVIEW" onClosing={handleClose} options={{ width: 1200, height: 800 }} />
      ) : null}
      {openResend ? (
        <Popout url={openUrlResend} title="PRS2022-ADMIN-PAPERPRESEND" onClosing={handleClose} options={{ width: 850, height: 800 }} />
      ) : null}
      {open ? (
        <Dialog
          open={open}
          fullWidth
          maxWidth={'lg'}
          onClose={handleClose}
          aria-labelledby="alert-dialog-title"
          aria-describedby="alert-dialog-description"
        >
          <FreePaperSubmissionForm
            mode={'modify'}
            abstractId={selectData.id}
            isPop={true}
            isAdmin={true}
            infoData={selectData}
            handleClose={handleClose}
          />
        </Dialog>
      ) : null}
    </Grid>
  );
};

export default PaperListPage;
